<div class="mn_dashboard">
  <div class="left_layout">
    <app-sidebar />
  </div>
  <div class="right_layout">
    <router-outlet />
  </div>
</div>
